const pendingKey = 'alfred.client.login.v110';

export function isClientAuthSurfaceV115(pathname, search = '') {
  const path = pathname.replace(/\/+$/, '');
  return path === '/client/authorize' ||
    (path === '/login' && new URLSearchParams(search).get('flow') === 'coding');
}

export function rememberClientLoginV110(path) {
  if (!path.startsWith('/client/authorize?')) return;
  sessionStorage.setItem(pendingKey, JSON.stringify({ path, expires: Date.now() + 600000 }));
}

export function consumeClientLoginV110(fallback) {
  const raw = sessionStorage.getItem(pendingKey);
  sessionStorage.removeItem(pendingKey);
  try {
    const value = JSON.parse(raw);
    if (value?.expires > Date.now() && typeof value.path === 'string' &&
        value.path.startsWith('/client/authorize?') && value.path.length <= 4096) {
      return value.path;
    }
  } catch { /* Ignore expired or malformed navigation state. */ }
  return fallback;
}

export function clientRedirectBaseV115(expected, clientID) {
  const native = {
    'alfred-dsh': 'com.alfredapi.dsh:/oauth/callback',
    'alfred-codex': 'com.alfredapi.codex:/oauth/callback',
    'alfred-code': 'com.alfredapi.code:/oauth/callback',
    'alfred-launcher': 'com.alfredapi.launcher:/oauth/callback',
  };
  if (native[clientID] && expected === native[clientID]) return expected;
  const url = new URL(expected);
  if (url.protocol !== 'http:' || url.hostname !== '127.0.0.1' || !url.port ||
      url.username || url.password || url.hash || url.search || url.pathname !== '/oauth/callback' ||
      url.href !== expected) throw new Error('INVALID_CALLBACK');
  return expected;
}

export function clientCallbackV110(expected, returned, state, clientID) {
  clientRedirectBaseV115(expected, clientID);
  const target = new URL(returned);
  const base = new URL(returned);
  base.search = '';
  if (base.href !== expected || target.username || target.password || target.hash ||
      [...target.searchParams.keys()].length !== 2 ||
      target.searchParams.get('state') !== state ||
      !target.searchParams.get('code')) throw new Error('INVALID_CALLBACK');
  return target.href;
}
